<script generic="T" lang="ts" setup>
import { NIcon } from '@novonordisk/studyhub-novoui/vue'
import Highlighter from 'vue-highlight-words'

const { tooltipPlacement = 'left' } = defineProps<{
  isDisabled: boolean
  isHovered: boolean
  isSelected: boolean
  searchWords: string[]
  itemText: string
  itemData: T
  size: 'small' | 'medium'
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
  tooltipText?: string
}>()

defineSlots<{
  prepend(): void
  append(): void
}>()
</script>

<template>
  <div
    v-tooltip="tooltipText ? { content: tooltipText, placement: tooltipPlacement } : undefined"
    :class="{
      'bg-general-low-emphasis-enabled': !isDisabled && isHovered && !isSelected,
      'bg-general-medium-emphasis-hover': isSelected,
      'text-ui-input-14': size === 'small',
      'text-ui-input-16': size === 'medium',
      'text-disabled-medium-emphasis cursor-default': isDisabled,
      'text-general-secondary cursor-pointer': !isDisabled,
    }"
    class="flex h-10 items-center gap-4 px-4 py-1"
  >
    <slot name="prepend" />
    <div
      :class="{
        'bg-general-medium-emphasis-hover': isSelected,
      }"
      class="flex-1 truncate"
    >
      <Highlighter
        :highlight-style="{}"
        :search-words="searchWords"
        :text-to-highlight="itemText"
        :title="itemText"
        auto-escape
        highlight-class-name="text-notifications-and-tags-on-strong-warning font-700 bg-transparent"
      />
    </div>
    <slot name="append">
      <div v-if="isSelected">
        <NIcon
          class="fill-notifications-and-tags-on-strong-warning"
          icon="tick"
          :size="16"
        />
      </div>
    </slot>
  </div>
</template>
